<div
  id="uzd-protocol"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="stat_date" />
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Права нирка розмірами:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_p_rozmir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Розташована:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="stat_p_roztash">
            <option value="типово">типово</option>
            <option value="атипово">атипово</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Товщина паренхіми:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_p_perenhimu" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ч.Л.К. підвищеної ехогенності:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_p_eho" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Лоханка:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="stat_p_lohanka">
            <option value="поширена">поширена</option>
            <option value="не поширена">не поширена</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Верхня третина сечоводу:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="stat_p_verh">
            <option value="поширена">поширена</option>
            <option value="не поширена">не поширена</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Наявність кальцифінованих судин:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_p_kalts" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('немає', 'stat_p_concrements')"> немає </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('є,   мм.', 'stat_p_concrements')"> є </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Конкременти:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="stat_p_concrements"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Дрібні ехо (+) включення:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_p_dribni_exo" />
        </clr-input-container>
      </div>
    </div>

    <br>
    <br>
    <br>
    <br>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ліва нирка розмірами:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_l_rozmir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Розташована:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="stat_l_roztash">
            <option value="типово">типово</option>
            <option value="атипово">атипово</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Товщина паренхіми:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_l_perenhimu" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ч.Л.К. підвищеної ехогенності:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_l_eho" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Лоханка:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="stat_l_lohanka">
            <option value="поширена">поширена</option>
            <option value="не поширена">не поширена</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Верхня третина сечоводу:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="stat_l_verh">
            <option value="поширена">поширена</option>
            <option value="не поширена">не поширена</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Наявність кальцифінованих судин:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_l_kalts" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('немає', 'stat_l_concrements')"> немає </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('є,   мм.', 'stat_l_concrements')"> є </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Конкременти:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="stat_l_concrements"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Дрібні ехо (+) включення:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_l_dribni_exo" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Сечовий міхур:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="stat_mihur" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки солевого діатезу', 'stat_results')"> ознаки солевого діатезу </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки мієліту обох нирок без порушення масажу сечі', 'stat_results')"> ознаки мієліту обох нирок без порушення масажу сечі </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки мієліту обох нирок з порушенням масажу сечі зліва', 'stat_results')"> ознаки мієліту обох нирок з порушенням масажу сечі зліва </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки мієліту обох нирок з порушенням масажу сечі справа', 'stat_results')"> ознаки мієліту обох нирок з порушенням масажу сечі справа</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('правобічний гідронефроз', 'stat_results')"> правобічний гідронефроз</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('лівобічний гідронефроз', 'stat_results')"> лівобічний гідронефроз</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('правобічна піелоектазія', 'stat_results')"> правобічна піелоектазія</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('лівобічна піелоектазія', 'stat_results')"> лівобічна піелоектазія</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('кисти обох нирок', 'stat_results')"> кисти обох нирок</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('киста лівої нирки', 'stat_results')"> киста лівої нирки</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('киста правої нирки', 'stat_results')"> киста правої нирки</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки пієлонефриту справа', 'stat_results')"> ознаки пієлонефриту справа</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки пієлонефриту зліва', 'ch_results')"> ознаки пієлонефриту зліва</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки гідрокалікозу зліва', 'stat_results')"> ознаки гідрокалікозу зліва</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ознаки гідрокалікозу справа', 'stat_results')"> ознаки гідрокалікозу справа</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЗАКЛЮЧЕННЯ:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="stat_results"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>
</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
